import {createFileRoute} from '@tanstack/react-router';
import {MobilePage} from '@/features/agent';

export const Route = createFileRoute('/_app/agents/mobile')({
  component: () => <MobilePage />,
});
